import { LinkModel } from '@/types';
import { buildAPIUrl, responseInterceptor } from './index';

export interface StatBankSearchRequest {
  searchTerm: string;
  filters: any[];
  pageSize: number;
  page: number;
  account?: string;
}

export interface StatBankItemType {
  statId: string;
  number: string;
  description: string;
  statLink?: LinkModel;
  statSubjects?: any[];
  group?: string;
}

export interface StatBankResult {
  reportId: string | number;
  reportTitle: string;
  reportUrl: string | { href: string; text: string };
  reportImage: string | { url: string; [key: string]: any };
  publishedDate: string | Date;
  directory: string | { name: string; url?: string; id?: string; key?: string; group?: string; parentName?: string };
  isLegacy: boolean;
  anchorTextColour?: string;
  items: StatBankItemType[];
  loading?: boolean;
  pageId?: number;
}

export interface StatBankSearchResponse {
  facets: any[];
  results: StatBankResult[];
  totalResults: number;
}

export const searchStatBanks = async (requestData: StatBankSearchRequest): Promise<StatBankSearchResponse> => {
  const response = await responseInterceptor(
    await fetch(`${await buildAPIUrl()}/umbraco/Api/StatBankListing/SearchStatBanks`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(requestData),
    }),
  );

  return response.json();
};
